import { Component, OnInit } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss']
})
export class HeaderMenuComponent implements OnInit {

  logo: string;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.logo = 'assets/' + this.appService.settings.css.logo;
  }

}
